import { ApolloProvider } from '@apollo/client';
import { ReactNode } from 'react';
import client from '@/utils/apolloClient.ts';

export default function ApolloClientProvider({
  children,
}: {
  children?: ReactNode;
}) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
